import {Item} from "@/lib/types";


export function safeObject(obj: object | undefined): any | [] {
  return obj ? obj : []
}

export function safeObjectKeys(obj: object | undefined): any[] {
  return obj ? Object.keys(obj) ?? [] : []
}

export function ResolveLabel(name: string, data?: Item[]): string {
  if (data) {
    const item = data.find(d => d.name == name);
    if (item) {
      return item.value
    }
  }
  return name

}


export function CompleteListWithTemplate(listSize: number, expectedSize: number, render: (i: number) => JSX.Element): JSX.Element[] {
  const els: JSX.Element[] = [];
  const emptyEls = expectedSize - listSize
  for (let i = 0; i < emptyEls; i++) {
    els.push(render(listSize + i))
  }

  return els;
}
